import { render, staticRenderFns } from "./franchiseeslist.vue?vue&type=template&id=519fbee2&scoped=true"
import script from "./franchiseeslist.vue?vue&type=script&lang=js"
export * from "./franchiseeslist.vue?vue&type=script&lang=js"
import style0 from "./franchiseeslist.vue?vue&type=style&index=0&id=519fbee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519fbee2",
  null
  
)

export default component.exports